import api, { ResponsePayloadWithData } from '.';

export type ExerciseCategory = {
  id: string;
  name: string;
  usage: number;
  score?: {
    maximum: number;
    achievable: number;
    achieved: number;
  };
  categories?: ExerciseCategory[];
};

export const getExerciseCategories = async ({
  moduleId,
  includeScore = false,
  includeSubModules = false,
}: {
  moduleId: string;
  includeScore?: boolean;
  includeSubModules?: boolean;
}) => {
  const { data } = await api.get<ResponsePayloadWithData<ExerciseCategory[]>>(
    `/studio/modules/${moduleId}/exercise-categories/usage`,
    {
      params: {
        includeScore,
        includeSubModules,
      },
    },
  );

  return data;
};
